/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Map_Lines_No_Vehicle_NetworkInputs */

const fr_map_lines_no_vehicle_network = /** @type {(inputs: Map_Lines_No_Vehicle_NetworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun véhicule ne circule sur ce réseau.`)
};

const en_map_lines_no_vehicle_network = /** @type {(inputs: Map_Lines_No_Vehicle_NetworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No vehicle is running on this network.`)
};

/**
* | output |
* | --- |
* | "No vehicle is running on this network." |
*
* @param {Map_Lines_No_Vehicle_NetworkInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const map_lines_no_vehicle_network = /** @type {((inputs?: Map_Lines_No_Vehicle_NetworkInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Map_Lines_No_Vehicle_NetworkInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_map_lines_no_vehicle_network(inputs)
	return en_map_lines_no_vehicle_network(inputs)
});